export default "__VITE_ASSET__CDjVtSEe__"